/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kind_Clear_Seal_HumInputs */

const en_kind_clear_seal_hum = /** @type {(inputs: Kind_Clear_Seal_HumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent`)
};

const de_kind_clear_seal_hum = /** @type {(inputs: Kind_Clear_Seal_HumInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesendet`)
};

/**
* | output |
* | --- |
* | "Sent" |
*
* @param {Kind_Clear_Seal_HumInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const kind_clear_seal_hum = /** @type {((inputs?: Kind_Clear_Seal_HumInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kind_Clear_Seal_HumInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kind_clear_seal_hum(inputs)
	return de_kind_clear_seal_hum(inputs)
});